import React from 'react';
import { assets } from '../../../assets';
import { statusColor, StatusIcon, stringifyStatus } from '../../../helpers/type-formatters';
import {
  ClockIcon,
  Container,
  DataBlock,
  DateContainer,
  Icon,
  StatusLabelContainer,
} from './components';
import { ListItemData } from './types';
import { FormattedMessage, useIntl } from 'react-intl';

const ListItemContent = (props: { data: ListItemData }): JSX.Element => {
  const intl = useIntl();
  return (
    <div className="flex flex-row items-center h-full hidden md:flex">
      <div className="flex-none flex flex-col justify-center mr-4">
        <StatusIcon status={props.data.status} />
      </div>
      <StatusLabelContainer>
        <span className="text-12">
          <b>{stringifyStatus(props.data.status, intl)}</b>
        </span>
        {props.data.direction ? (
          <span className="text-10 text-lightgray">
            {intl.formatMessage({ id: `order.direction.${props.data.direction}` })}
          </span>
        ) : null}
      </StatusLabelContainer>
      {props.data.iconVisible ? (
        <div className="flex-none" style={{ width: 50 }}>
          <Icon src={assets.icons.security_icon} alt="eszköz" width={40} height={40} />
        </div>
      ) : null}
      <div className="flex-1 flex flex-col justify-center mr-4" style={{ minWidth: 140 }}>
        <span className="text-12">
          <b>{props.data.title}</b> {props.data.titleExtension || null}
        </span>
        {props.data.transactionCode ? (
          <span className="text-12">
            <FormattedMessage id={'listItem.id'} /> <b>{props.data.transactionCode}</b>
          </span>
        ) : null}
      </div>
      {props.data.detailBlocks.map((blockData, index) => (
        <DataBlock key={index} data={blockData} />
      ))}
      <DateContainer>
        <ClockIcon src={assets.icons.clock} />
        <div className="text-10 text-lightgray text-right">{props.data.date}</div>
      </DateContainer>
    </div>
  );
};

const ListItemMobileContent = (props: { data: ListItemData }): JSX.Element => {
  const intl = useIntl();
  return (
    <div className="flex flex-col h-full md:hidden">
      <div className="flex flex-row items-center pb-1">
        <div className="flex-none flex flex-col justify-center mr-4">
          <StatusIcon status={props.data.status} />
        </div>
        <div className="flex-none flex flex-col justify-center">
          <div className="flex-none flex flex-row items-center">
            <span className="text-12">
              <b>{stringifyStatus(props.data.status, intl)}</b>
            </span>
            {props.data.direction ? (
              <span className="text-10 text-lightgray ml-1">
                {intl.formatMessage({ id: `order.direction.${props.data.direction}` })}
              </span>
            ) : null}
          </div>
          <div className="flex flex-row items-center">
            <ClockIcon src={assets.icons.clock} />
            <span className="text-10 text-lightgray">{props.data.date}</span>
          </div>
        </div>
      </div>
      <div className="flex-1 flex flex-row justify-center py-1">
        {props.data.iconVisible ? (
          <div className="mr-1">
            <Icon src={assets.icons.security_icon} alt="eszköz" width={40} height={40} />
          </div>
        ) : null}
        <div className="flex-1 flex flex-col justify-center">
          <span className="text-12">
            <b>{props.data.title}</b> {props.data.titleExtension || null}
          </span>
          {props.data.transactionCode ? (
            <span className="text-12">
              Azonosító: <b>{props.data.transactionCode}</b>
            </span>
          ) : null}
        </div>
      </div>
      {props.data.detailBlocks.map((blockData, index) => (
        <DataBlock key={index} data={blockData} />
      ))}
    </div>
  );
};

const ListItem = (props: {
  data: ListItemData;
  onClick: () => void;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const handleOnClick = (): void => {
    props.onClick();
  };

  return (
    <Container
      onClick={handleOnClick}
      decorationColor={statusColor(props.data.status)}
      decorationShadowColor={statusColor(props.data.status)}
      style={props.style}
      mobileHeight={props.mobileHeight}
    >
      <ListItemContent data={props.data} />
      <ListItemMobileContent data={props.data} />
    </Container>
  );
};

export default ListItem;
